<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../../../../assets/images/New_Icons/home-transprent-icon.svg"
                                     title="Home"></a>
        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- START FORM VALIDATION STATES -->
      <div class="block" [hidden]="!pgLoad">
        <div class="page-header">
          <span class="page-header__title">Devices</span>
          <img src="../../../../../../../assets/images/New_Icons/refresh-icon.svg" title="Refresh" (click)="ngOnInit()">
        </div>
        <div class="Reports_form_div">
          <form role="form" [formGroup]="addMapDeviceForm" name="addmapdevice">
            <div class="reports-form-container">
              <!--AQU Device Number Field-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>AQU Device Number</mat-label>
                <mat-select id="aqudevicenumber" formControlName="device_id" name="device_id"
                            [(ngModel)]="customerDevice.device_id">
                  <mat-option value="undefined" disabled>Select AQU Device Number</mat-option>
                  <mat-option *ngFor="let device of nonMappedDevice && nonMappedDevice.aquDevices" [value]="device.id">
                    {{ (device?.number) }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.device_id.invalid"><i>Select device number</i></mat-hint>
                <mat-hint *ngIf="f.device_id.valid"><i>Device number selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.device_id.touched) && f.device_id.errors">
                  <i *ngIf="f.device_id.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <!--Sale Type Field-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Sale Type</mat-label>
                <mat-select id="saletype" formControlName="saleTypeId" name="saleTypeId"
                            [(ngModel)]="customerDevice.sale_type_id">
                  <mat-option value="undefined" disabled>Select Sale Type</mat-option>
                  <mat-option *ngFor="let saleType of saleTypes" [value]="saleType.id">
                    {{ (saleType?.name) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!--Tinto Device Number Field-->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>STINTO Device Number</mat-label>
                <mat-select id="pairedDeviceId" formControlName="pairedDeviceId" name="pairedDeviceId"
                            [(ngModel)]="customerDevice.paired_device_id">
                  <mat-option value="undefined" disabled>Select TINTO Device Number</mat-option>
                  <mat-option *ngFor="let tinto of nonMappedDevice && nonMappedDevice.tintoDevices" [value]="tinto.id">
                    {{ (tinto?.number) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="row">
              <div class="buttons-div">
                <div class="transactions-button-container" (click)="addMapDevice()">
                  <button class="transaction-submit-button" [disabled]="mapDeviceDoubleClick">
                    <span class="icon"><img src="../../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                    <span class="text">Submit</span>
                  </button>
                </div>
                <div class="transactions-button-container">
                  <button class="transaction-close-button" (click)="cancel()">
                    <span class="icon"><img src="../../../../../../../assets/images/New_Icons/cross-icon.svg"></span>
                    <span class="text">Cancel</span>
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="customerDevices && customerDevices.length>0" class="panel-body table-responsive">
              <table class="table">
                <thead class="thead-light">
                <tr>
                  <th scope="col">S.No.</th>
                  <th scope="col">AQU Device Number</th>
                  <th scope="col">TINTO Device Number</th>
                  <th scope="col">Device Type</th>
                  <th scope="col">Sale Type</th>
                  <th scope="col">Manufacture Date</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let MapDevice of customerDevices; let i=index">
                  <td scope="row">{{ i + 1 }}</td>
                  <td>{{ MapDevice.device.number }}</td>
                  <td>
                    {{ MapDevice && MapDevice.calorimeterDevice && MapDevice.calorimeterDevice && MapDevice.calorimeterDevice.number ? MapDevice.calorimeterDevice.number : 'NA' }}
                  </td>
                  <td>
                    {{ MapDevice && MapDevice.device && MapDevice.device.deviceModel && MapDevice.device.deviceModel.name }}
                    {{ MapDevice && MapDevice.calorimeterDevice && MapDevice.calorimeterDevice.deviceModel && MapDevice.calorimeterDevice.deviceModel.name ? MapDevice.calorimeterDevice.deviceModel.name : ' ' }}
                  </td>
                  <td>
                    {{ MapDevice?.saleType?.name || 'NA' }}
                  </td>
                  <td>{{ MapDevice && MapDevice.device && MapDevice.device.manufactured_date | date:"dd-MMM-yyyy" }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
      <!-- END FORM VALIDATION STATES -->
    </div>
  </div>
  <!-- END PAGE CONTENT WRAPPER -->
</div>
<!-- END PAGE CONTENT WRAPPER -->
